export const CONTAINER_BREAKPOINTS = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '428px',
  tablet: '768px',
  tabletL: '1024px',
  desktop: '1280px',
  desktopWide: '1440px',
  desktopXL: '1920px'
};

// Pre-computed max-width values (CONTAINER_BREAKPOINTS start - 1px) for media queries.
export const CONTAINER_MAX = Object.fromEntries(
  Object.entries(CONTAINER_BREAKPOINTS).map(([key, value]) => [
    key,
    `${parseInt(value, 10) - 1}px`
  ])
) as Record<keyof typeof CONTAINER_BREAKPOINTS, string>;

// Maximum width of centered page content. Backgrounds (header/footer bars)
// stay full-bleed; only the inner content is capped to this width and centered.
export const CONTENT_MAX_WIDTH = '1440px';
